import { DiscoverFields } from "./fields";
import { DiscoverConstants } from "./discoverConstants";

export const MotiveSpecifDetail = {
  motiveDetail32: {
    description: "Does not recognize",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail33: {
    description: "Duplicate posting",
    isDuplicate: true,
    fields: []
  },
  motiveDetail34: {
    description: "Recurring payment",
    isRecurrent: true,
    fields: [
      {
        fieldObject: {
          ...DiscoverFields.cancellationOrReturnReason,
          label: "Cancellation Reason"
        },
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cancellationDate,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cancellationMethod,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerName,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerNumber,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cancellationNumber,
        isRequired: false
      }
    ]
  },
  motiveDetail35: {
    description: "Altered amount",
    fields: [
      {
        fieldObject: DiscoverFields.correctAmount,
        isRequired: false,
        cashBackValidation: {
          mandatoryforCashBack: false
        }
      },
      {
        fieldObject: DiscoverFields.merchandiseCorrectAmount,
        isDependant: true,
        isRequired: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [
          DiscoverConstants.CashOverOptions[0].value,
          DiscoverConstants.CashOverOptions[2].value
        ],
        cashBackValidation: {
          mandatoryforCashBack: true
        }
      },
      {
        fieldObject: DiscoverFields.cashOverCorrectAmount,
        isRequired: true,
        isDependant: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [
          DiscoverConstants.CashOverOptions[1].value,
          DiscoverConstants.CashOverOptions[2].value
        ],
        cashBackValidation: {
          mandatoryforCashBack: true
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail36: {
    description: "Paid by other means",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail38: {
    description: "Credit/Debit posted incorrectly",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail40: {
    description: "Non Receipt of Goods/Services",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.merchandiseDescription,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.orderCancelled,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.cancellationDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.cancellationMethod,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerName,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerNumber,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.cancellationNumber,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.promisedDeliveryDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.reason,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail41: {
    description: "Quality of Goods/Services",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail42: {
    description: "Credit Not Processed",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.cancelledOrReturned,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.returnedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[1].value]
      },
      {
        fieldObject: DiscoverFields.returnMethod,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[1].value]
      },
      {
        fieldObject: DiscoverFields.cancellationDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[0].value]
      },
      {
        fieldObject: DiscoverFields.cancellationMethod,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[0].value]
      },
      {
        fieldObject: DiscoverFields.reason,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerName,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[0].value]
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerNumber,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[0].value]
      },
      {
        fieldObject: DiscoverFields.cancellationNumber,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[0].value]
      },
      {
        fieldObject: DiscoverFields.merchandiseServiceDescription,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.reservationDate,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.creditReceiptDate,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail44: {
    description: "Card Present-Swiped Transaction",
    fields: [
      {
        fieldObject: DiscoverFields.authorizationApproved,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cardPresentAtTransactionTime,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail45: {
    description: "Card Present-Keyed Transaction",
    fields: [
      {
        fieldObject: DiscoverFields.authorizationApproved,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cardPresentAtTransactionTime,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail46: {
    description: "Card Not Present Transactions",
    fields: [
      {
        fieldObject: DiscoverFields.authorizationApproved,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cardPresentAtTransactionTime,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.avsValidated,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cidValidated,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail47: {
    description: "Declined Authorization",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      }
    ]
  },
  motiveDetail48: {
    description: "No Authorization",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      }
    ]
  },
  motiveDetail49: {
    description: "Expired Card",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      }
    ]
  },
  motiveDetail52: {
    description: "Sale Exceed Authorization Amount",
    fields: [
      {
        fieldObject: DiscoverFields.correctAmount,
        isRequired: false,
        cashBackValidation: {
          mandatoryforCashBack: false
        }
      },
      {
        fieldObject: DiscoverFields.merchandiseCorrectAmount,
        isDependant: true,
        isRequired: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [
          DiscoverConstants.CashOverOptions[0].value,
          DiscoverConstants.CashOverOptions[2].value
        ],
        cashBackValidation: {
          mandatoryforCashBack: true
        }
      },
      {
        fieldObject: DiscoverFields.cashOverCorrectAmount,
        isRequired: true,
        isDependant: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [
          DiscoverConstants.CashOverOptions[1].value,
          DiscoverConstants.CashOverOptions[2].value
        ],
        cashBackValidation: {
          mandatoryforCashBack: true
        }
      }
    ]
  },
  motiveDetail53: {
    description: "Address Verification Service or CID failure",
    fields: [
      {
        fieldObject: DiscoverFields.authorizationApproved,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.avsValidated,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cardPresentAtTransactionTime,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cidValidated,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.priorAuthorizationWithAvsAndCid,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  motiveDetail64: {
    description: "Counterfeit Goods",
    fields: [
      {
        fieldObject: DiscoverFields.counterfeitConfirmationDate,
        isRequired: true
      }
    ]
  },
  motiveDetail65: {
    description: "Terms of Sale Not As Represented",
    fields: [
      {
        fieldObject: DiscoverFields.promisedDeliveryDate,
        isRequired: true
      }
    ]
  },
  motiveDetail66: {
    description: "Acquirer Stand In Processing Error",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/configurations/discoverConfigs/motiveCodes.js